/** Dev/training helper: POST /api/kb/query and log a compact response summary. */
export async function kbQueryDebug(payload: unknown) {
  console.log("[KB SPOKEN] request payload:", payload);

  const r = await fetch("/api/kb/query", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const json = await r.json().catch(() => ({}));
  const j = json as Record<string, unknown>;
  const matches = j.matches as unknown[] | undefined;
  const first = matches?.[0] as Record<string, unknown> | undefined;
  console.log("[KB SPOKEN] response:", {
    ok: r.ok,
    status: r.status,
    signature: j.signature,
    matchesCount: matches?.length ?? 0,
    topSlug: first?.slug,
    topScore: first?.score,
    topHasChunkText: typeof first?.chunkText === "string",
    keys: Object.keys(j || {}),
  });

  return { ok: r.ok, status: r.status, json };
}
